import { atom } from 'jotai';
import * as poiState from './atoms';

export const waitingForPoiClick = atom((get) =>
  get(poiState.editPointOfInterest)?.state === 'WaitingForPoint' ||
  get(poiState.blisterToAdd)?.state === 'WaitingForCenter' ||
  get(poiState.blisterToAdd)?.state === 'WaitingForEdge'
);

export const cancelPOIAdd = atom(
  null,
  (get, set) => {
    set(poiState.blisterToAdd, undefined);
    set(poiState.editPointOfInterest, { state: 'Inactive', pointOfInterest: undefined, isManuallyCreated: undefined });
  }
);
